export default {
  id: '',
  fieldData: {
    fieldId: 0,
    fieldName: ''
  },
  clickFlag: false,
  clickModalFlag: false,
  modalId: null,
  modalPlantingId: null,
  isScroll: true
}
